import { sendXray } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';

import { emitAnalyticEvent } from '../experimentAnalytic';
import { AnalyticEventNames } from '../experimentAnalytic/eventNames';
import { getChangeDesignUrl } from './getChangeDesignUrl';

// tempexp_17340-start

export const changeDesignToolbar = () => {
    emitAnalyticEvent(AnalyticEventNames.TOOLBAR_BRAND_PAGE_CLICK);
    sendXray('toolbar-brand-page-click');
    const url = getChangeDesignUrl();
    url.searchParams.append('source', 'toolbar');
    opener(url.toString());
};

// tempexp_17340-end
